<script>
import { BBadge } from 'bootstrap-vue'
import {ChangeLogApi} from "@core/api";
import Overlay from "@core/components/common/Overlay.vue";
import HamletTable from "@core/components/common/HamletTable.vue";
import dateRenderer from "@core/mixins/date-renderer";
import Button from "@core/components/common/Button.vue";
import ChangesModal from "@core/components/common/changelog/ChangesModal.vue";
import ChangeLogModal from "@core/components/common/changelog/ChangeLogModal.vue";
import RelationsModal from "@core/components/common/changelog/RelationsModal.vue";
import ChangesRelationsModal from "@core/components/common/changelog/ChangesRelationsModalV2.vue";

export default {
    name: 'ChangeLog',
    mixins: [dateRenderer],
    components: {
        ChangesRelationsModal,
        RelationsModal, ChangeLogModal, ChangesModal, Button, HamletTable, Overlay, BBadge},
    props: {
        label: {
            required: true
        },
        relationsLabel: {
            default() {
                return this.$t('Component(ChangeLog):relations-label');
            }
        },
        namespace: {
            required: true
        },
        businessObject: {
            required: true
        },
        primaryKey: {
            required: true
        },
        relations: {
            type: Array,
            default() {
                return [];
            }
        }
    },

    data() {
        return {
            columns: [
                {
                    key: 'createdAt',
                    label: this.$t('Component(Label):created-at'),
                    title: this.$t('Component(Label):created-at'),
                    order: 1,
                    active: true,
                },
                {
                    key: 'user',
                    label: this.$t('Component(Grid):column-user-details'),
                    title: this.$t('Component(Grid):column-user-details'),
                    order: 1,
                    active: true,
                },
                {
                    key: 'actions',
                    label: this.$t('Component(Grid):column-actions'),
                    title: this.$t('Component(Grid):column-actions'),
                    order: 1,
                    active: true,
                },
            ],
            records: [],
            showLoading: true,

            changesToShow: [],
            relationsToShow: []
        };
    },

    methods: {
        fetch() {
            this.showLoading = true;
            if (this.relations.length) {
                this.showLoading = false;
                this.records = this.relations;
                this.$refs.table.makeRequest();
            } else {
                ChangeLogApi
                    .get(this.namespace, this.businessObject, this.primaryKey)
                    .then(r => {
                        this.records = r.data;
                        this.$refs.table.makeRequest();
                    })
                    .finally(() => this.showLoading = false)
            }
        },
        renderTable(config, callback) {
            const start = config.page * config.perPage - config.perPage;
            let end = start + config.perPage;
            if (end > this.records.length) {
                end = undefined;
            }
            callback(
                this.records.length,
                this.records.slice(start, end)
            );
        },
        showChanges(changelog) {
            this.changesToShow = changelog.changes;
            if (changelog.relations.length > 0) {
                this.relationsToShow = changelog.relations;
            }

            if (this.changesToShow.length > 0 && this.relationsToShow.length > 0) {
                this.$refs.changesRelationsModal.show();
            } else {
                if (this.changesToShow.length > 0) {
                    this.$refs.changesModal.show();
                } else {
                    this.$refs.relationsModal.show();
                }
            }
        },
    },

    watch: {
        namespace() {

        },
        businessObject() {

        },
        primaryKey() {

        }
    },

    created() {
        this.fetch();
    }
}
</script>

<template>
    <Overlay :show="showLoading">
        <ChangesModal
            ref="changesModal"
            :changes="changesToShow"
        />
        <RelationsModal
            :label="relationsLabel"
            ref="relationsModal"
            :relations="relationsToShow"
        />
        <ChangesRelationsModal
            ref="changesRelationsModal"
            :label="label"
            :relations-label="relationsLabel"
            :changes="changesToShow"
            :relations="relationsToShow"
        />
        <HamletTable
            ref="table"
            card-class="mb-0 pb-0"
            :columns="columns"
            :fetch="renderTable"
        >
            <template #header-label>{{ label }}</template>

            <template #cell-createdAt="data">
                {{ renderDateTime(data.item.createdAt) }}
            </template>

            <template #cell-user="data">
                {{ data.item.parameters.user.name }}
                <b-badge>{{ data.item.parameters.user.email }}</b-badge>
            </template>

            <template #cell-actions="data">
                <Button
                    v-if="data.item.changes"
                    class="btn-sm mr-1"
                    @click="showChanges(data.item)"
                >
                    {{ $t('Component(Button):show-changes') }}
                </Button>
            </template>
        </HamletTable>
    </Overlay>
</template>
